export default __webpack_public_path__ + "static/media/no_result.cb4abf9e.png";